import axios from "axios"
import baseURL, { ticketBaseURL } from "../configs/api"

export const post_CommonFile = (data: any, tenantId: string) => {
    return axios({
        url: `${baseURL}commonFile/upload`,
        method: "POST",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "multipart/form-data"
        },
        withCredentials: true,
        data: data
    }).then(response => response.data);
}

export const commonFileUrl = `${baseURL}commonFile/Get?name=`;

export const upload_CommonFileSupportTicket = (formData: FormData) => {

    return axios({
        url: `${ticketBaseURL}commonFile/upload`,
        method: "POST",
        headers: { "Content-Type": "multipart/form-data" },
        data: formData
    }).then(response => response.data);
};